import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './app.frontend.types'

@Injectable({ providedIn: 'root' })
export class app_custom_generic_log_writeService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { application_name: string, process_name: string, log_level: number, message: string }): Promise<void> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.application_name)) {
      $missingRequiredInParams.push('\'application_name\'');
    }
    if (isNil($inParams.process_name)) {
      $missingRequiredInParams.push('\'process_name\'');
    }
    if (isNil($inParams.log_level)) {
      $missingRequiredInParams.push('\'log_level\'');
    }
    if (isNil($inParams.message)) {
      $missingRequiredInParams.push('\'message\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/custom_generic_log_write`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

